import { CartAddEvent } from '@theme/events';

// Persistent timer with localStorage and cart change detection
const TIMER_KEY = 'cart_timer_start';
const CART_COUNT_KEY = 'cart_count_last';


// Add CSS to hide timer placeholders initially
const style = document.createElement('style');
style.textContent = `
  .cart-banner__content[data-timer-text*="[timer-"],
  .cart-reserved-timer__text[data-timer-text*="[timer-"] {
    visibility: hidden;
  }
  .cart-banner__content.timer-ready,
  .cart-reserved-timer__text.timer-ready {
    visibility: visible !important;
  }
`;
document.head.appendChild(style);

function getTimerStart() {
  const stored = localStorage.getItem(TIMER_KEY);
  if (!stored) {
    const now = Date.now();
    localStorage.setItem(TIMER_KEY, now.toString());
    return now;
  }
  const timestamp = parseInt(stored);
  return timestamp;
}

function resetTimer() {
  const now = Date.now();
  localStorage.setItem(TIMER_KEY, now.toString());
  return now;
}

function getCartCount() {
  const cartBubble = document.querySelector('.cart-bubble__text-count');
  const cartItemCount = document.querySelector('[ref="cartItemCount"]');
  
  if (cartBubble && cartBubble.textContent.trim()) {
    return parseInt(cartBubble.textContent.trim()) || 0;
  }
  if (cartItemCount && cartItemCount.textContent.trim()) {
    return parseInt(cartItemCount.textContent.trim()) || 0;
  }
  return 0;
}

function checkCartChanges() {
  const currentCount = getCartCount();
  const lastCount = parseInt(localStorage.getItem(CART_COUNT_KEY) || '0');
  
  // Reset timer if cart becomes empty or items are added
  if ((currentCount === 0 && lastCount > 0) || (currentCount > lastCount)) {
    resetTimer();
  }
  
  localStorage.setItem(CART_COUNT_KEY, currentCount.toString());
}

// Every element that can host a [timer-N] placeholder: the promo cart banner
// and the "order is reserved" bar.
const TIMER_SELECTORS = '.cart-banner__content, .cart-reserved-timer__text';

function updateTimer() {
  const holders = document.querySelectorAll(TIMER_SELECTORS);
  if (!holders.length) return;

  const timerStart = getTimerStart();
  const elapsed = Math.floor((Date.now() - timerStart) / 1000);

  holders.forEach((holder) => {
    if (!holder.dataset.timerText) return;

    // Replace all [timer-X] patterns with countdown
    const updatedText = holder.dataset.timerText.replace(/\[timer-(\d+)\]/g, (match, minutes) => {
      const totalSeconds = parseInt(minutes) * 60;
      const remaining = totalSeconds - (elapsed % totalSeconds);
      const mins = Math.floor(remaining / 60);
      const secs = remaining % 60;
      const timeString = `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
      return timeString;
    });

    holder.innerHTML = updatedText;

    // Show now that the placeholder is processed
    holder.classList.add('timer-ready');
  });
}

// Listen for cart add events to reset timer
document.addEventListener('DOMContentLoaded', () => {
  let timerInterval = null;

  // Reset timer when items are added to cart
  document.addEventListener('cart:add', () => {
    resetTimer();
  });
  
  // Also listen for the theme's CartAddEvent
  document.addEventListener('CartAddEvent', () => {
    resetTimer();
  });
  
  // Tick once a second regardless of whether the drawer is open. The work is
  // a string replace on at most two nodes, and keeping it always-on means the
  // countdown is already correct the moment the drawer appears.
  timerInterval = setInterval(updateTimer, 1000);
  updateTimer();

  // The cart drawer re-renders its markup on every cart change, which replaces
  // the timer node with a fresh one still holding the raw [timer-N] text. That
  // node is hidden until it has been processed, so repaint it immediately
  // instead of waiting up to a second for the next tick (which looked like the
  // timer glitching out).
  const repaint = () => updateTimer();

  document.addEventListener('cart:update', repaint);
  document.addEventListener('cart:refresh', repaint);

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(TIMER_SELECTORS) || node.querySelector?.(TIMER_SELECTORS)) {
          updateTimer();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
});
